import type React from 'react';

/**
 * Keyboard support for a non-button element that acts on click (UX-31).
 * Enter/Space only fire when the element itself has focus, so nested buttons and inputs keep their own keys.
 */
export const clickableProps = (
  onActivate: () => void,
  role: 'button' | 'link' = 'button'
): Pick<React.HTMLAttributes<HTMLElement>, 'role' | 'tabIndex' | 'onClick' | 'onKeyDown'> => ({
  role,
  tabIndex: 0,
  onClick: onActivate,
  onKeyDown: (e) => {
    if (e.target !== e.currentTarget) return;
    if (e.key === 'Enter' || (role === 'button' && e.key === ' ')) {
      e.preventDefault();
      onActivate();
    }
  },
});
